import React from 'react';

interface NewPillProps {
  children: React.ReactNode;
  ctaText?: string;
  onClick?: () => void;
  className?: string;
}

const pillStyle: React.CSSProperties = {
  border: '1px solid var(--dualite-border-primary)',
  backdropFilter: 'blur(6px)',
  // boxShadow: '0px 0px 0px 2px rgba(0, 0, 0, 0.4), 0px 8px 8px 0px rgba(0, 0, 0, 0.16)',
};

const badgeStyle: React.CSSProperties = {
  background: '#233B22',
  border: '1px solid #8DD29066',
  borderRadius: '40px',
};

export default function NewPill({ children, ctaText = 'Try it now', onClick, className = '' }: NewPillProps) {
  const Component = onClick ? 'button' : 'div';
  const baseClassName = `group flex items-center gap-2.5 px-1 pr-3 py-1 rounded-full cursor-pointer transition-all duration-200 shadow-custom ${className}`;

  const interactiveProps = onClick
    ? { onClick, type: 'button' as const, className: baseClassName, style: pillStyle }
    : { className: baseClassName, style: pillStyle };

  return (
    <Component {...interactiveProps}>
      {/* Green "New" badge */}
      <span
        className="flex-shrink-0 px-2.5 py-0.5 text-[#8dd290] text-[11px] font-semibold leading-[1.5]"
        style={badgeStyle}
      >
        New
      </span>

      {/* Main label */}
      <span
        className="text-[var(--dualite-text-primary)] text-[12px] font-normal leading-[1.4]"
        style={{ fontFamily: 'var(--dualite-font-family-display)' }}
      >
        {children}
      </span>

      {/* CTA */}
      {ctaText && (
        <span className="flex items-center gap-0.5 text-[var(--dualite-text-tertiary)] text-[12px] font-normal group-hover:text-[var(--dualite-text-primary)] transition-colors duration-200">
          {ctaText}
          <div className="i-ph:caret-right text-[11px]" />
        </span>
      )}
    </Component>
  );
}
